module.exports = __webpack_public_path__ + "static/quiz-c57cb165277472ac63df2f715fb6b942.png";